import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { getUrlLang } from '@/plugins/common'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: getUrlLang()
})

export default i18n
